import React from 'react'
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom'


/**
 * Generate private routes
 * @param {bool type parameter that allows you to enter} isAuthenticaded 
 * @module component that allows redirection
 * @module rest all other arguments
 */
export const PrivateRoute = ({isAuthenticaded, component: Component, ...rest}) => {
    
    localStorage.setItem('lastPath', rest.location.pathname);

    
    return (
        <Route {...rest}
           
            component={ (props)=>(
                
                    (isAuthenticaded)
                        ? (<Component {...props} />)

                        : (<Redirect to="/auth" />)
                )
            }
        />
            
        
    )
}

PrivateRoute.propTypes = {
    isAuthenticaded: PropTypes.bool.isRequired,
    component: PropTypes.func.isRequired
}